import { isCliImmediateShutdownRequested } from '../../runtime/cli-process-interrupt.js';
import { CliSqliteInterrupted } from '../../sqlite/code-nav-cache/database.js';
import { createWalkYieldState, walkWorkspaceTreeAsync } from './walk-workspace-tree.js';

function assertNotShutdown(): void {
  if (isCliImmediateShutdownRequested()) throw new CliSqliteInterrupted();
}

export async function collectWorkspacePathsAsync(resolved: string): Promise<string[]> {
  const paths: string[] = [];
  const state = createWalkYieldState();
  await walkWorkspaceTreeAsync(resolved, resolved, (rel) => {
    assertNotShutdown();
    paths.push(rel);
  }, state);
  return paths;
}
